/**
 * Created by Mark on 18/04/2017.
 */


import ApplicationServices from './base-service.js';
import Constants from '../constants/content.js';
import Action from '../actions/default.js';

class ContentService {

    constructor(){
        this.isAuthenticated = false;
        this.timeout = null;
    }

    makeNewModule(name , learningIETF , supportIETF , description){
        return ApplicationServices.call(Constants.MAKE_CONTENT , {description:description , name:name , learning:learningIETF , support:supportIETF}).then(function(response){
            return response;
        });
    }

    fetchModulesForLanguage(ietf){
        return ApplicationServices.call(Constants.FETCH_CONTENT_LANGAUGE , {ietf:ietf}).then(function(response){
            Action.update(Constants.ON_MY_CONTENT_UPDATE , response.modules);
        });
    }

    fetchModules(){
        return ApplicationServices.call(Constants.FETCH_CONTENT , {}).then(function(response){
                Action.update(Constants.ON_MY_CONTENT_UPDATE , response.modules);
        });
    }

    fetchVerbs(verbsUID , fromLanguage){
        return ApplicationServices.call(Constants.VERBS_FETCH , {verbUid:verbsUID ,  toLanguage:'en-GB' , fromLanguage:fromLanguage , gameId:16}).then(function(response){
            Action.update(Constants.ON_VERBS_FETCH , {id:verbsUID , verbs:response.verbTranslations});
        });
    }

    fetchCatalog(catalogUID , learning , support){
        return ApplicationServices.call(Constants.GET_CATALOG_VOCAB , {catalogUIDs:[catalogUID] ,  toLanguage:learning , fromLanguage:support}).then(function(response){
            Action.update(Constants.ON_VOCAB_FETCH , {id:catalogUID , vocab:response.allVocabs});
        });
    }

    fetchCatalogSummary(catalogUID){
        return ApplicationServices.call(Constants.GET_CATALOG_SUMMARY , {catalogID:catalogUID }).then(function(response){
            Action.update(Constants.ON_SUMMARY_FETCH , {id:catalogUID   , summary:response.catalog});
        });
    }

    addVocab(catalogUID , vocabUID){
        return ApplicationServices.call(Constants.ADD_VOCAB , {catalogUID:catalogUID , vocabUID:vocabUID});
    }

    removeVocab(catalogUID , vocabUID)
    {
        return ApplicationServices.call(Constants.REMOVE_VOCAB , {catalogUID:catalogUID , vocabUID:vocabUID});
    }

    uploadAudio(soundData){

        return ApplicationServices.call(Constants.UPLOAD_AUDIO , {data:soundData});
    }

    makeVocab(catalogUID , learningIETF , supportIETF , learningtext , supportText , imageIsDataURL , imageDataUrl , learnIsDataURL , supportIsDataURL , learnDataUrl , supportDataUrl , isEdit){
        return ApplicationServices.call(Constants.MAKE_VOCAB , {isEdit:isEdit || false , supportIsDataURL:supportIsDataURL, learnIsDataURL:learnIsDataURL , catalogUID:catalogUID , learnDataUrl:learnDataUrl, supportDataUrl:supportDataUrl , learningIETF:learningIETF , supportIETF:supportIETF , learningtext:learningtext , supportText:supportText , imageIsDataURL:imageIsDataURL , imageDataUrl:imageDataUrl});
    }

    editVocab(vocabUID , catalogUID , learningIETF , supportIETF , learningtext , supportText , imageIsDataURL , imageDataUrl , learnIsDataURL , supportIsDataURL , learnDataUrl , supportDataUrl , isEdit){
        return ApplicationServices.call(Constants.MAKE_VOCAB , {vocabUID:vocabUID || false , isEdit:true , supportIsDataURL:supportIsDataURL, learnIsDataURL:learnIsDataURL , catalogUID:catalogUID , learnDataUrl:learnDataUrl, supportDataUrl:supportDataUrl , learningIETF:learningIETF , supportIETF:supportIETF , learningtext:learningtext , supportText:supportText , imageIsDataURL:imageIsDataURL , imageDataUrl:imageDataUrl});
    }

    publish(catalogUID){
        return ApplicationServices.call(Constants.PUBLISH, {catalogUID:catalogUID})
    }

    unPublish(catalogUID){
        return ApplicationServices.call(Constants.UN_PUBLISH, {catalogUID:catalogUID})
    }
}


export default new ContentService();


// WEBPACK FOOTER //
// ./src/services/content-service.js